module.exports = __webpack_public_path__ + "static/media/Avec guitare 1.1f134bd2.jpg";